// extracted by mini-css-extract-plugin
module.exports = {"bar":"SecondaryBar_bar__384c1","leftPart":"SecondaryBar_leftPart__69de3","container":"SecondaryBar_container__db3b2"};